import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

export interface PagedResponse<T> {
	data: T[]
	total: number
	pageIndex: number
	pageSize: number
};

@Injectable({
	providedIn: 'root'
})
export abstract class RestService {

	public url: string;
	constructor(protected http: HttpClient) { }

	public find(query = {}, pageIndex = 0, pageSize = 10) {
		let httpParams = new HttpParams(),
			skip = pageIndex * pageSize;
		Object.keys(query).forEach(function (key) {
			if (query[key] !== null && query[key] !== '' && query[key] !== undefined) {
				httpParams = httpParams.append(key, query[key]);
			}
		});

		httpParams = httpParams.append('$skip', String(skip));
		httpParams = httpParams.append('$limit', String(pageSize));

		return this.http.get(this.url, {
			params: httpParams
		});
	}

	public get(id) {
		return this.http.get(`${this.url}/${id}`);
	}

	public put(id, payload) {
		return this.http.put(`${this.url}/${id}`, payload);
	}

	public patch(id, payload) {
		return this.http.patch(`${this.url}/${id}`, payload);
	}

	public post(payload) {
		return this.http.post(this.url, payload);
	}

	public delete(id) {
		return this.http.delete(`${this.url}/${id}`);
	}
}
